export const SHOPIFY_CLIENT_ID = "547c6a1b8c9d25e5dd9e8c4d261ede7d";
export const OUR_PRICE_MULTIPLIER = 0.035;
export const REFRESH_TIMEOUT = 2000;
export const BASE_URL = process.env.REACT_APP_API_URL + "/";
export const SHOPIFY_NAME = "Store";
